import styled from "styled-components/macro";

import { IStepperStyleProps } from "./types";

export const StepContainer = styled.div<IStepperStyleProps>`
  padding-left: ${({ orientation }) => (orientation === "horizontal" ? "8px" : "")};
  padding-right: ${({ orientation }) => (orientation === "horizontal" ? "8px" : "")};
`;
